module.exports = __webpack_public_path__ + "img/baseline-keyboard_arrow_down-24px.c3d75740.svg";